const snapshotUrl = `${window.__env.VUE_APP_BASE_URL}/v1/services/snapshot/`;
const token = localStorage.getItem('additionalTokenImage');

export const downloadImage = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    if (response.status == 404 || response.status == 403) {
      return 404;
    }
    return blob;
  } catch (error) {
    return null;
  }
};

export const convertBlobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const saveImageToIndexedDB = async (binaryData, imageName) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("imagesDB", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("images")) {
        db.createObjectStore("images", { keyPath: "name" });
      }
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction(["images"], "readwrite");
      const store = transaction.objectStore("images");

      const data = {
        name: imageName,
        binaryData: binaryData,
        date: new Date().toISOString(),
      };
      store.put(data);

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = (error) => {
        reject(error);
      };
    };

    request.onerror = (error) => {
      reject(error);
    };
  });
};

export const getImageFromIndexedDB = async (imageName) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("imagesDB", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("images")) {
        db.createObjectStore("images", { keyPath: "name" });
      }
    };
    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction(["images"], "readwrite");
      const store = transaction.objectStore("images");
      const getRequest = store.get(imageName);

      getRequest.onsuccess = () => {
        if (getRequest.result) {
          const oldDate = getRequest.result.date;
          const newDate = new Date();
          const differenceInMilliseconds = newDate.getTime() - new Date(oldDate).getTime();
          const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

          if (differenceInMinutes > 1440) { // 24 hors
            const deleteRequest = store.delete(imageName);
            resolve(null);
          } else {
            resolve(getRequest.result.binaryData);
          }
        } else {
          resolve(null);
        }
      };

      getRequest.onerror = (error) => {
        reject(error);
      };
    };
    request.onerror = (error) => {
      reject(error);
    };
  });
};

export const loadImage = async (url, imageName) => {
  const cachedImage = await getImageFromIndexedDB(imageName);
  if (cachedImage) {
    return cachedImage;
  } else {
    const binaryData = await downloadImage(url);
    if (binaryData != 404) {
      await saveImageToIndexedDB(binaryData, imageName);
    }
    return binaryData;
  }
};

//Function to load and save the images uses src/utils/cameraImageUtils
const getImageSrc = async (cameraId) => {
  const imageUrl = `${snapshotUrl}${cameraId}?access_token=${token}`;
  try {
    const binaryData = await loadImage(imageUrl, cameraId);
    //Delete animation loader
    const overlay = document.getElementById(`overlay-${cameraId}`);
    const loader = document.getElementById(`loader-${cameraId}`);
    if (overlay) {
      overlay.remove();
    }
    if (loader) {
      loader.remove();
    }
    if(binaryData == 404){
      const imageUrl = './img/cameras/image_not_available.jpg';
      document.querySelector(`#image-${cameraId}`).src=`${imageUrl}`;
    }else{
      const base64Image = await convertBlobToBase64(binaryData);
      document.querySelector(`#image-${cameraId}`).src=`${base64Image}`;
    }

    return imageUrl;
  } catch (error) {
    return imageUrl;
  }
};

export { getImageSrc };
